export default {"src":"/pro/_next/static/media/avax.67b836ac.svg","height":2501,"width":2501,"blurWidth":0,"blurHeight":0};